<div class="setting-container">
    <app-ongletlayout
        storageId="setting"
        [ongletLinks]="tableLinkForSetting"
        [title]="'Système'"
    >
        <div>
            <router-outlet></router-outlet>
        </div>
    </app-ongletlayout>
</div>